import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import ForgotForm from '../components/ForgotForm/ForgotForm.js'
import Button from '../components/Button/Button.js'
import Header from '../components/Header/Header.js'
import Footer from '../components/Footer/Footer.js'

var pf_config = require('../pf_config.json');

class AtWork extends Component {

  constructor(props){
    super(props);
  }

  componentWillMount(){
    const { user } = this.props;
    
  }

  componentDidMount(){
    window.document.title = "AtWork Password - Pattycake";
  }


  render(){

    const { user } = this.props;

    return <div className="body-stretch">
      <Header transparent={true}/>
      <div className="stretched">
        
        <div className="section-breaker section-breaker-white">
          <div className="container">
            <div className="row row-push-down" id="what">
              <div className="col-md-12">
                <div className="section-label">
                  Why use Pattycake at work?
                </div>
              </div>
              <div className="col-md-12">
                <h2>Powerful tools and seemless collaboration</h2>
                <p className="lead soft">
                
                </p>
              </div>
            </div>

            <div className="row row-push-down-extra">
              <div className="col-md-6">
                <img src="/img/Building-bro-cropped.svg"/>
              </div>
              <div className="col-md-1"/>
              <div className="col-md-5">
                <p className="lead soft">
                  Tired of mismatched standards and unorganized files?
                </p>
                <p className="lead">
                  <strong>Pattycake securely stores patterns for you.</strong>
                </p>
                <hr/>
                 <p className="lead soft">
                  Need to quickly onboard new team members?
                </p>
                <p className="lead">
                  <strong>Bring them along, no long term contracts.</strong>
                </p>
                <hr/>
                 <p className="lead soft">
                  Can't find the perfect pattern for your custom feature?
                </p>
                <p className="lead">
                  <strong>Use the most powerful hatch pattern editor, ever.</strong>
                </p>
                <hr/>
                 <p className="lead soft">
                  Tired of upgrading extentions and plugins each year?
                </p>
                <p className="lead">
                  <strong>Pattycake is always up to date. No yearly versions.</strong>
                </p>
              </div>
            </div>
          </div>
        </div>


        <div className="section-breaker">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-6 text-center">
                <blockquote>
                  <p>But wait, there's more.</p>
                </blockquote>
              </div>
            </div>
          </div>
        </div>

        <div className="section-breaker section-breaker-white">
          <div className="container">
            <div className="row row-push-down" id="what">
              <div className="col-md-12">
                <div className="section-label">
                  Lions, tigers, and bears - oh my
                </div>
              </div>
              <div className="col-md-12">
                <h2>Projects, templates, signatures, themes...</h2>
                
              </div>
            </div>

            <div className="row row-push-down-extra">
              <div className="col-md-5">
                <p className="lead">
                  There are dozens of features built into Pattycake that are specifically designed to eliminate the friction we've felt when trying to get our jobs done.
                </p>
                <p className="lead p-push-down">
                  Here are just a few:
                </p>
                <ul className="list-bulleted list-spaced-extra">
                  <li><span className="fa-li"><i className="fas fa-angle-right"></i></span>Tag patterns with the project name or address, so anyone can easily find all of the standards they need.</li>
                  <li><span className="fa-li"><i className="fas fa-angle-right"></i></span>Access to every Pattycake Template: custom calculators we've designed that will generate versions of the most common patterns based on just a few variables.</li>
                  <li><span className="fa-li"><i className="fas fa-angle-right"></i></span>Customizable signatures that are automatically appended to every one of your company's .PAT files - making sure the output of your work stays yours.</li>
                  <li><span className="fa-li"><i className="fas fa-angle-right"></i></span>Compatibility with any software your firm uses, with specific built in error detection for Revit and AutoCAD's import requirements.</li>
                </ul>
                
              </div>
               <div className="col-md-1"/>
              <div className="col-md-6">
                <img src="/img/Architect-bro-cropped.svg"/>
              </div>
            </div>
          </div>
        </div>

        <div className="section-breaker">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-6 text-center">
                <blockquote>
                  <p>Did we mention there's a 30 day free trial?</p>
                </blockquote>
              </div>
            </div>
          </div>
        </div>

        <div className="section-breaker section-breaker-white">
          <div className="container">
            
            <div className="row justify-content-center row-push-down-extra">
            <div className="col-md-5">
              <div className="col-themed">
                <h2 className="text-center text-900">
                  Pattycake for Firms
                </h2>
                <div className="price-breakout">
                  <div className="price-breakout-number">
                    <span className="dollar-sign">$</span>{pf_config.plans.teams.price}
                    <span className="price-breakout-description"> / month</span>
                  </div>
                  <div className="price-breakout-description">
                    per 5 user license<br/>
                    ($2 / user)<br/>
                  </div>
                </div>

                <div className="flex-center-column">
                   {
                    !user.isLoggedIn && 
                    <Link to={"/sign-up?after=" + window.btoa("pattycake-for-forms-sign-up") + "&in=" + window.btoa("Pattycake for Firms") + "&tg=" + window.btoa("Let's get you setup.")} className="button-link">
                      <Button
                        display="Setup Your Firm"
                        color="success"
                        size="medium"
                      />
                    </Link>
                  }
                  {
                    user.isLoggedIn && 
                    <Link to="/pattycake-for-firms-sign-up" className="button-link">
                      <Button
                        display="Setup Your Firm"
                        color="success"
                        size="medium"
                      />
                    </Link>
                  }
                </div>
              </div>
            </div>
            
          </div>
          </div>
        </div>
      </div>
      <Footer/>
    </div>
  }
}

const mapStateToProps = (state) => {
  const { user } = state;

  return {
    user
  }
}

export default connect(mapStateToProps)(AtWork);



// WEBPACK FOOTER //
// ./src/routes/AtWork.js